import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { motion, LayoutGroup } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { database } from '../firebase/config';
import { onValue } from 'firebase/database';
import { insightsRef } from '../firebase/config';
import { addTestInsights } from '../utils/testData';
import lukaSlogan from '../images/aboutluka/LUKA slogan.png';


// Firebase imports (실제 프로젝트에서 사용)
//import { database, insightsRef } from '../firebase/config';
//import { onValue } from 'firebase/database';

export default function InsightPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);

  // 안전한 날짜 처리 함수
  const formatDate = (dateValue) => {
    if (!dateValue) {
      return '날짜 없음';
    }

    try {
      let date;
      const trimmedValue = typeof dateValue === 'string' ? dateValue.trim() : String(dateValue);
      
      // 다양한 날짜 형식 처리
      if (typeof dateValue === 'string') {
        // 한글 날짜 형식 처리: "2025년 12월 16일 / 15시 27분 04초" (다양한 공백/슬래시 변형 지원)
        const koreanDateWithTimeMatch = trimmedValue.match(/(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일\s*[\/\s]*\s*(\d{1,2})\s*시\s*(\d{1,2})\s*분\s*(\d{1,2})\s*초/);
        if (koreanDateWithTimeMatch) {
          const year = koreanDateWithTimeMatch[1];
          const month = String(koreanDateWithTimeMatch[2]).padStart(2, '0');
          const day = String(koreanDateWithTimeMatch[3]).padStart(2, '0');
          const hour = String(koreanDateWithTimeMatch[4]).padStart(2, '0');
          const minute = String(koreanDateWithTimeMatch[5]).padStart(2, '0');
          const second = String(koreanDateWithTimeMatch[6]).padStart(2, '0');
          date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
          }
        }
        
        // 한글 날짜 형식 처리 (시간 없음): "2025년 12월 16일"
        const koreanDateMatch = trimmedValue.match(/(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
        if (koreanDateMatch) {
          const year = koreanDateMatch[1];
          const month = String(koreanDateMatch[2]).padStart(2, '0');
          const day = String(koreanDateMatch[3]).padStart(2, '0');
          date = new Date(`${year}-${month}-${day}`);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
          }
        }
        
        // YYYYMMDD HHMMSS 형식 처리
        if (/^\d{8}\s+\d{6}$/.test(trimmedValue)) {
          const year = trimmedValue.substring(0, 4);
          const month = trimmedValue.substring(4, 6);
          const day = trimmedValue.substring(6, 8);
          const hour = trimmedValue.substring(9, 11);
          const minute = trimmedValue.substring(11, 13);
          const second = trimmedValue.substring(13, 15);
          date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
          }
        }
        
        // YYYYMMDD 형식 처리
        if (/^\d{8}$/.test(trimmedValue)) {
          const year = trimmedValue.substring(0, 4);
          const month = trimmedValue.substring(4, 6);
          const day = trimmedValue.substring(6, 8);
          date = new Date(`${year}-${month}-${day}`);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
          }
        }
        
        // ISO 문자열 형식 처리 (YYYY-MM-DD, YYYY-MM-DDTHH:MM:SS 등)
        if (trimmedValue.includes('T') || /^\d{4}-\d{2}-\d{2}/.test(trimmedValue)) {
          date = new Date(trimmedValue);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
        }
        }
        
        // 마지막 시도: JavaScript Date 생성자로 파싱
        date = new Date(trimmedValue);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        }
      } else if (dateValue instanceof Date) {
        date = dateValue;
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        }
      } else {
        date = new Date(dateValue);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        }
      }

      // 모든 파싱 시도 실패 시 fallback 처리
        console.warn('Invalid date value:', dateValue);
      if (typeof dateValue === 'string' && dateValue.length > 0) {
        // 한글 날짜 형식이 부분적으로라도 있으면 그 부분만 표시
        const partialMatch = trimmedValue.match(/(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
        if (partialMatch) {
          return `${partialMatch[1]}년 ${partialMatch[2]}월 ${partialMatch[3]}일`;
        }
        // 숫자 패턴이 있으면 추출 시도
        const numberMatch = trimmedValue.match(/(\d{4})[-\/\.]?(\d{1,2})[-\/\.]?(\d{1,2})/);
        if (numberMatch) {
          const year = numberMatch[1];
          const month = String(numberMatch[2]).padStart(2, '0');
          const day = String(numberMatch[3]).padStart(2, '0');
          date = new Date(`${year}-${month}-${day}`);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
          }
        }
        // 숫자만 있는 경우 처음 8자리 추출 시도
        const digitsOnly = trimmedValue.replace(/\D/g, '');
        if (digitsOnly.length >= 8) {
          const year = digitsOnly.substring(0, 4);
          const month = digitsOnly.substring(4, 6);
          const day = digitsOnly.substring(6, 8);
          date = new Date(`${year}-${month}-${day}`);
          if (!isNaN(date.getTime())) {
      return date.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
          }
        }
      }
      
      return '날짜 정보 없음';
    } catch (error) {
      console.error('Date formatting error:', error, 'Date value:', dateValue);
      // 에러 발생 시에도 원본 값에서 날짜 추출 시도
      if (typeof dateValue === 'string') {
        const partialMatch = dateValue.match(/(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
        if (partialMatch) {
          return `${partialMatch[1]}년 ${partialMatch[2]}월 ${partialMatch[3]}일`;
        }
      }
      return '날짜 정보 없음';
    }
  };

  // content에서 첫 번째 이미지 URL 추출 함수
  const extractFirstImageUrl = (content) => {
    if (!content) return null;
    
    // 마크다운 이미지 문법 ![alt](url) 패턴 매칭
    const imageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
    const matches = imageRegex.exec(content);
    
    if (matches && matches[2]) {
      return matches[2]; // URL 부분 반환
    }
    
    // HTML img 태그도 지원 <img src="url">
    const htmlImageRegex = /<img[^>]+src\s*=\s*['"]\s*([^'"]+)\s*['"]/i;
    const htmlMatches = htmlImageRegex.exec(content);
    
    if (htmlMatches && htmlMatches[1]) {
      return htmlMatches[1];
    }
    
    return null;
  };

  // 기본 placeholder 이미지 생성 함수
  const getPlaceholderImage = (index, category) => {
    // 카테고리별 기본 이미지 설정
    const categoryImages = {
      'trend': [
        'https://images.unsplash.com/photo-1586023492125-27b2c045efd7',
        'https://images.unsplash.com/photo-1600210492493-0946911123ea',
        'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea'
      ],
      'tip': [
        'https://images.unsplash.com/photo-1554118811-1e0d58224f24',
        'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c',
        'https://images.unsplash.com/photo-1567538096630-e0c55bd6374c'
      ],
      'news': [
        'https://images.unsplash.com/photo-1560472354-b33ff0c44a43',
        'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4',
        'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87'
      ]
    };

    const categoryImageList = categoryImages[category] || categoryImages['trend'];
    const imageIndex = index % categoryImageList.length;
    return `${categoryImageList[imageIndex]}?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80`;
  };

  // 섬네일 이미지 URL 가져오기
  const getThumbnailUrl = (insight, index) => {
    // 1. content에서 이미지 URL 추출 시도
    const extractedImage = extractFirstImageUrl(insight.content);
    if (extractedImage) {
      return extractedImage;
    }
    
    // 2. thumbnail 필드가 있는 경우
    if (insight.thumbnail) {
      return insight.thumbnail;
    }
    
    // 3. 기본 placeholder 이미지 사용
    return getPlaceholderImage(index, insight.category);
  };

  // 이미지 로드 에러 처리
  const handleImageError = (e, insight, index) => {
    console.log('이미지 로드 실패:', e.target.src);
    
    // 구글 드라이브 이미지인 경우 대안 URL 시도
    const originalSrc = e.target.src;
    if (originalSrc.includes('drive.google.com')) {
      const fileIdMatch = originalSrc.match(/[?&]id=([a-zA-Z0-9_-]+)/);
      if (fileIdMatch) {
        const fileId = fileIdMatch[1];
        const alternatives = [
          `https://drive.google.com/uc?id=${fileId}`,
          `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`,
          `https://lh3.googleusercontent.com/d/${fileId}`
        ];
        
        // 현재 URL이 아닌 다른 대안 시도
        const currentAltIndex = alternatives.findIndex(alt => alt === originalSrc);
        const nextAltIndex = currentAltIndex + 1;
        
        if (nextAltIndex < alternatives.length) {
          e.target.src = alternatives[nextAltIndex];
          return;
        }
      }
    }
    
    // 모든 대안이 실패하면 placeholder 이미지 사용
    e.target.src = getPlaceholderImage(index, insight.category);
  };

  // Firebase 데이터 로드
  useEffect(() => {
    console.log('InsightPage: Firebase 데이터 로드 시작');
    console.log('InsightPage: Firebase config 확인:', database);
    console.log('InsightPage: insightsRef 경로:', insightsRef().toString());
    
    const unsubscribe = onValue(insightsRef(), (snapshot) => {
      try {
        const data = snapshot.val();
        console.log('InsightPage: Firebase에서 받은 데이터:', data);
        console.log('InsightPage: 데이터 타입:', typeof data);
        console.log('InsightPage: 데이터가 null인가?', data === null);
        console.log('InsightPage: 데이터가 undefined인가?', data === undefined);
        
        if (data) {
          const insightsList = Object.entries(data).map(([id, insight]) => ({
            id,
            ...insight,
            date: insight.date || new Date().toISOString().split('T')[0],
            thumbnail: insight.thumbnail || '', // thumbnail이 없으면 빈 문자열로 설정
            url: insight.url || '', // url이 없으면 빈 문자열로 설정
            // 썸네일 노출 위치(글별 설정, admin 편집기) — 기본 중앙
            thumbFocus: insight.thumbFocus || 'center'
          }));
          // 날짜 순으로 정렬 (최신순)
          setInsights(insightsList.sort((a, b) => new Date(b.date) - new Date(a.date)));
          console.log('InsightPage: 처리된 인사이트 목록:', insightsList);
        } else {
          console.log('InsightPage: Firebase에서 데이터가 없습니다');
          setInsights([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('InsightPage: 데이터 처리 오류:', error);
        setInsights([]);
        setLoading(false);
      }
    }, (error) => {
      console.error('InsightPage: Firebase 연결 오류:', error);
      console.error('InsightPage: 오류 상세 정보:', error.code, error.message);
      // 네트워크 오류 등 처리
      setInsights([]);
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, []);

  const tabs = [
    { id: 'all', label: '전체' },
    { id: 'trend', label: '트렌드' },
    { id: 'tip', label: '인테리어 팁' },
    { id: 'news', label: '뉴스' }
  ];

  const getCategoryLabel = (category) => {
    switch (category) {
      case 'trend':
        return '트렌드';
      case 'tip':
        return '인테리어 팁';
      case 'news':
        return '뉴스';
      default:
        return category;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'trend':
        return 'bg-black';
      case 'tip':
        return 'bg-black';
      case 'news':
        return 'bg-black';
      default:
        return 'bg-gray-500';
    }
  };

  // Extract preview text
  const extractPreviewText = (content) => {
    if (!content) return '';
    
    // Remove markdown images
    let text = content.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '');
    
    // Remove markdown links (keep text only)
    text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
    
    // Remove markdown headings
    text = text.replace(/^#{1,6}\s+/gm, '');
    
    // Remove markdown bold/italic
    text = text.replace(/\*\*(.*?)\*\*/g, '$1');
    text = text.replace(/\*(.*?)\*/g, '$1');
    
    // Remove HTML tags
    text = text.replace(/<[^>]*>/g, '');
    
    // Multiple spaces/newlines to single space
    text = text.replace(/\s+/g, ' ').trim();
    
    // Limit to 120 characters
    return text.length > 120 ? text.substring(0, 120) + '...' : text;
  };

  const filteredInsights = activeTab === 'all' 
    ? insights 
    : insights.filter(insight => insight.category === activeTab);

  // 카드 그리드 — 썸네일 비율 4:3 통일(랜덤 비율 제거, 2026-07-16 클라이언트 피드백),
  // 노출 위치는 글별 thumbFocus(objectPosition)로 조정
  const MasonryGrid = ({ insights }) => {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {insights.map((insight, index) => (
          <motion.article
            key={insight.id}
            className="group cursor-pointer"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
            whileHover={{ y: -4 }}
            onClick={() => navigate(`/insight/${insight.id}`)}
          >
            <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500">
              {/* Thumbnail — 4:3 통일 */}
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={getThumbnailUrl(insight, index)}
                  alt={insight.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  style={{ objectPosition: insight.thumbFocus || 'center' }}
                  onError={(e) => handleImageError(e, insight, index)}
                  loading="lazy"
                />
                
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* Category badge */}
                <div className="absolute top-4 right-4">
                  <span className={`${getCategoryColor(insight.category)} text-white text-xs px-3 py-1 rounded-full font-medium font-sans`}>
                    {getCategoryLabel(insight.category)}
                  </span>
                </div>
                
                {/* 이미지 로딩 시 배경 표시 */}
                <div className="absolute inset-0 bg-gray-200 -z-10"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Date */}
                <div className="text-sm text-gray-500 mb-3 font-sans">
                  {formatDate(insight.date)}
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold mb-3 line-clamp-2 text-gray-900 group-hover:text-gray-700 transition-colors font-sans">
                  {insight.title}
                </h3>

                {/* Preview */}
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 font-sans">
                  {extractPreviewText(insight.content)}
                </p>

                {/* Read more */}
                <div className="mt-4">
                  <span className="text-gray-900 text-sm font-medium group-hover:text-gray-600 transition-colors font-sans">
                    자세히 보기 →
                  </span>
                </div>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    );
  };

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-white font-sans">
        {/* Navbar */}
        <Navbar />
        
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      </div>
    );
  }

  // Empty state
  if (insights.length === 0) {
    return (
      <div className="min-h-screen bg-white font-sans">
        {/* Navbar */}
        <Navbar />

        <main className="pt-16 py-0">
          {/* Hero Section */}
          <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
            <div className="w-full px-4">
              <motion.div
                className="text-center max-w-4xl mx-auto"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h1 className="text-2xl md:text-3xl font-normal text-gray-900 mb-6 tracking-wide font-sans">
                  Insight and Contents
                </h1>
                <p className="text-base text-gray-500 font-light max-w-2xl mx-auto">
                  영감을 주는 공간 이야기
                </p>
              </motion.div>
            </div>
          </section>
          
          <section className="py-12">
            <div className="w-full px-4">
              <div className="text-center py-12">
                <p className="text-gray-600 mb-4">등록된 인사이트가 없습니다.</p>
                <button
                  onClick={async () => {
                    console.log('테스트 데이터 추가 버튼 클릭됨');
                    const success = await addTestInsights();
                    if (success) {
                      alert('테스트 데이터가 추가되었습니다. 페이지를 새로고침해주세요.');
                    } else {
                      alert('테스트 데이터 추가에 실패했습니다.');
                    }
                  }}
                  className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium"
                >
                  테스트 데이터 추가
                </button>
              </div>
            </div>
          </section>
        </main>
      </div>
    );
  }

  // Main render
  return (
    <div className="flex flex-col min-h-screen bg-white font-sans">
      {/* Navbar */}
      <Navbar />
      

      {/* Main Content */}
      <main className="flex-1 pt-16 py-0 font-sans">
        {/* Hero Section - Simplified */}
        <section className="py-0 bg-gradient-to-br from-gray-50 to-white font-sans">
          <div className="w-full px-4">
            <motion.div
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {/* 페이지 제목 공통 기준: text-2xl md:text-3xl font-normal tracking-wide (Portfolio/Contact와 통일) */}
              <h2 className="text-2xl md:text-3xl font-normal text-gray-900 mb-4 tracking-wide font-sans">Insight and Contents</h2>
            </motion.div>
          </div>
          <section className="py-8"></section>
        </section>

        {/* Content Section */}
        <section className="">
          <div className="w-full px-4">
            <div className="flex flex-col lg:flex-row gap-8 font-sans">
              
              {/* Left Sidebar - 3/12 */}
              <div className="lg:w-3/12 pl-4 font-sans">
                <div className="sticky top-24 space-y-8">
                  
                  {/* Category Navigation */}
                  <motion.div
                    className="space-y-3"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                  >
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4 font-sans">
                      카테고리
                    </h3>
                    <LayoutGroup>
                      {tabs.map((tab, index) => (
                        <motion.button
                          key={tab.id}
                          onClick={() => setActiveTab(tab.id)}
                          className={`block w-full text-left px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-300 relative overflow-hidden font-sans ${
                            activeTab === tab.id
                              ? 'text-white'
                              : 'text-gray-600 hover:text-gray-900'
                          }`}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.6, delay: 0.1 + index * 0.1 }}
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                        >
                          {/* Background */}
                          <div className={`absolute inset-0 rounded-xl transition-all duration-300 ${
                            activeTab === tab.id
                              ? 'bg-gray-900 scale-100'
                              : 'bg-gray-50 scale-95 hover:scale-100 hover:bg-gray-100'
                          }`} />
                          
                          {/* Text */}
                          <span className="relative z-10 font-sans">{tab.label}</span>
                          
                          {/* Active indicator */}
                          {activeTab === tab.id && (
                            <motion.div
                              className="absolute right-3 top-1/2 w-2 h-2 bg-white rounded-full"
                              layoutId="activeCategory"
                              style={{ transform: 'translateY(-50%)' }}
                            />
                          )}
                        </motion.button>
                      ))}
                    </LayoutGroup>
                  </motion.div>
                </div>
              </div>

              {/* Right Content - 9/12 */}
              <div className="lg:w-9/12 pr-4">
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                >
                  {filteredInsights.length > 0 ? (
                    <MasonryGrid insights={filteredInsights} />
                  ) : (
                    <div className="text-center py-12">
                      <p className="text-gray-600 font-sans">
                        {activeTab === 'all' ? '등록된 글이 없습니다.' : `${getCategoryLabel(activeTab)} 카테고리에 등록된 글이 없습니다.`}
                      </p>
                    </div>
                  )}
                </motion.div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 text-center flex justify-center items-center">
          <img 
            src={lukaSlogan} 
            alt="LUKA Slogan" 
            className="w-[25%] h-auto object-contain filter invert brightness-0"
          />
        </div>
      </footer>

    </div>
  );
}